export default {
    data() {
        return {
            isFullScreen: false,
        }
    },
    methods: {
        fullScreen(e) {
            e.preventDefault();
            var me = this,
                isFullScreen = me.isFullScreen;
            if (me.isFullScreen) {
                isFullScreen = false;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else {
                    isFullScreen = true;
                }
                window.location.reload();
            } else {
                var el = document.documentElement;
                isFullScreen = true;
                if (el.requestFullscreen) {
                    el.requestFullscreen();
                } else if (el.msRequestFullscreen) {
                    el.msRequestFullscreen();
                } else if (el.mozRequestFullScreen) {
                    el.mozRequestFullScreen();
                } else if (el.webkitRequestFullscreen) {
                    el.webkitRequestFullscreen();
                } else {
                    isFullScreen = false;
                }
            }

            me.isFullScreen = isFullScreen;
        },
    }
}